<template>
  <section :id="content.anchor" class="workshop">
    <header class="workshop__header">
      <div class="workshop__container row">
        <figure class="row__item -span-4 project__image" :style="{ backgroundImage: `url(${content.image})` }" />
        <div class="row__item -span-8 project__content">
          <ContentTitle align-left flat>{{ content.title }}</ContentTitle>
          <ContentRaw class="project__text" :html="{ before: content.description }"></ContentRaw>
        </div>
      </div>
    </header>
    <Project v-for="(project, projectKey) in content.projects" :key="projectKey" :content="project"> </Project>
  </section>
</template>

<script>
import { ContentTitle, ContentRaw } from '@/components/content'
import Project from '@/components/partials/Project.vue'

export default {
  name: 'WorkshopSection',
  components: { Project, ContentTitle, ContentRaw },
  props: {
    content: { type: Object, required: true }
  }
}
</script>
